<script setup lang="ts">
import type {Populated} from '~/types/populated'
import type {Feature, Media} from '~/types/legacy'

interface FeaturePreview extends Populated<Feature> {
  image: Populated<Media>
}

const props = defineProps<{
  functionality: FeaturePreview
}>()

const title = props.functionality.name
const description = props.functionality.description
const icon = props.functionality.image.url
</script>

<template>
  <div class="flex flex-col items-center">
    <div class="flex h-16 w-16 items-center justify-center rounded-xl bg-main-500 bordershadow-lg-main">
      <img v-if="icon" :src="icon" :alt="title" class="block h-10 w-10 select-none fill-current text-white" />
    </div>
    <p class="mt-2 text-center font-bold text-gray-800">
      {{ title }}
    </p>
    <p class="prose-sm text-center">
      {{ description }}
    </p>
  </div>
</template>
